import $cliente from '@/data/cliente'
import loadView from './loadView'

export default (
	modulo = 0,
	privilegio = 0,
	path = '/',
	componentPath = '',
	name = '',
	componentName = '',
	clientsComponentPath = [],
	props
) => {
	const clientId = Number($cliente.get('id'))

	for (let clientData of clientsComponentPath) {
		componentPath = clientData.clientId.includes(clientId) ? clientData.componentPath : componentPath
	}

	return {
		modulo,
		privilegio,
		path,
		props,
		component: loadView(componentPath),
		name
	}
}
